/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Current scheduling state of the deployment
 */
export enum DeploymentSchedulingState {
	SCHEDULED = "scheduled",
	PLACED = "placed",
}
